import axios from "axios";
import {
  TENANT_DETAILS_REQUEST,
  TENANT_DETAILS_SUCCESS,
  TENANT_DETAILS_FAIL,
  TENANT_UPDATE_CLINICNAME_REQUEST,
  TENANT_UPDATE_CLINICNAME_SUCCESS,
  TENANT_UPDATE_CLINICNAME_FAIL,
  TENANT_UPDATE_SUPPORTEMAIL_REQUEST,
  TENANT_UPDATE_SUPPORTEMAIL_SUCCESS,
  TENANT_UPDATE_SUPPORTEMAIL_FAIL,
  TENANT_UPDATE_OPERATINGCOUNTRY_REQUEST,
  TENANT_UPDATE_OPERATINGCOUNTRY_SUCCESS,
  TENANT_UPDATE_OPERATINGCOUNTRY_FAIL,
  TENANT_UPDATE_ONBOARDING_STATUS_REQUEST,
  TENANT_UPDATE_ONBOARDING_STATUS_SUCCESS,
  TENANT_UPDATE_ONBOARDING_STATUS_FAIL,
  TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_REQUEST,
  TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_SUCCESS,
  TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_FAIL,
  TENANT_UPDATE_LOGO_REQUEST,
  TENANT_UPDATE_LOGO_SUCCESS,
  TENANT_UPDATE_LOGO_FAIL,
  TENANT_UPDATE_CLINIC_DETAILS_REQUEST,
  TENANT_UPDATE_CLINIC_DETAILS_SUCCESS,
  TENANT_UPDATE_CLINIC_DETAILS_FAIL,
  TENANT_UPDATE_REGIONAL_SETTINGS_REQUEST,
  TENANT_UPDATE_REGIONAL_SETTINGS_SUCCESS,
  TENANT_UPDATE_REGIONAL_SETTINGS_FAIL,
  TENANT_UPDATE_SCHEDULING_SETTINGS_REQUEST,
  TENANT_UPDATE_SCHEDULING_SETTINGS_SUCCESS,
  TENANT_UPDATE_SCHEDULING_SETTINGS_FAIL,
  TENANT_UPDATE_SCHEDULING_SETTINGS_RESET,
  TENANT_UPDATE_DENTAL_CHAIRS_REQUEST,
  TENANT_UPDATE_DENTAL_CHAIRS_SUCCESS,
  TENANT_UPDATE_DENTAL_CHAIRS_FAIL,
  TENANT_UPDATE_COMPANY_DETAILS_REQUEST,
  TENANT_UPDATE_COMPANY_DETAILS_SUCCESS,
  TENANT_UPDATE_COMPANY_DETAILS_FAIL,
  TENANT_UPDATE_SUBSCRIPTION_STATUS_REQUEST,
  TENANT_UPDATE_SUBSCRIPTION_STATUS_SUCCESS,
  TENANT_UPDATE_SUBSCRIPTION_STATUS_FAIL,
  TENANT_GET_SUBSCRIPTION_LIMITS_REQUEST,
  TENANT_GET_SUBSCRIPTION_LIMITS_SUCCESS,
  TENANT_GET_SUBSCRIPTION_LIMITS_FAIL,
  TENANT_GET_STRIPE_INVOICES_REQUEST,
  TENANT_GET_STRIPE_INVOICES_SUCCESS,
  TENANT_GET_STRIPE_INVOICES_FAIL,
  TENANT_GET_PUBLIC_DETAILS_REQUEST,
  TENANT_GET_PUBLIC_DETAILS_SUCCESS,
  TENANT_GET_PUBLIC_DETAILS_FAIL,
  TENANT_DETAILS_BY_SLUG_REQUEST,
  TENANT_DETAILS_BY_SLUG_SUCCESS,
  TENANT_DETAILS_BY_SLUG_FAIL,
  TENANT_INVITE_USER_REQUEST,
  TENANT_INVITE_USER_SUCCESS,
  TENANT_INVITE_USER_FAIL,
  TENANT_UPDATE_DEFAULT_COORDINATOR_REQUEST,
  TENANT_UPDATE_DEFAULT_COORDINATOR_SUCCESS,
  TENANT_UPDATE_DEFAULT_COORDINATOR_FAIL,
  TENANT_UPDATE_TENANT_USER_PERMISSIONS_REQUEST,
  TENANT_UPDATE_TENANT_USER_PERMISSIONS_SUCCESS,
  TENANT_UPDATE_TENANT_USER_PERMISSIONS_FAIL,
  TENANT_DELETE_ACCOUNT_REQUEST,
  TENANT_DELETE_ACCOUNT_SUCCESS,
  TENANT_DELETE_ACCOUNT_FAIL,
  TENANT_DELETE_ACCOUNT_RESET,
} from "../constants/tenantConstants";
// import { USER_LOGIN_SUCCESS } from "../constants/userConstants";
import { AUTH_LOGIN_SUCCESS } from "../constants/authConstants";

export const listTenantDetails = (slug) => async (dispatch, getState) => {
  try {
    dispatch({ type: TENANT_DETAILS_REQUEST });

    const {
      authLogin: { userInfo },
    } = getState();

    // console.log("Fetching tenant details for tenantID:", userInfo.tenantID);

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const tenantID = userInfo.tenantID;

    const { data } = await axios.get(
      `/api/${slug}/tenants/${tenantID}`,
      config
    );

    // console.log("API Response data:", data); // Add this line to see the response

    dispatch({
      type: TENANT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.error("Error fetching tenant details:", error); // Add this line for error logging
    dispatch({
      type: TENANT_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listTenantDetailsBySlugAction =
  (slug) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_DETAILS_BY_SLUG_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        `/api/${slug}/tenants/get-tenant-details`,
        config
      );

      dispatch({
        type: TENANT_DETAILS_BY_SLUG_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_DETAILS_BY_SLUG_FAIL,
        payload:
          error.response && error.response.data
            ? error.response.data
            : { message: error.message },
      });
    }
  };

export const updateTenantClinicNameAction =
  (clinicName, slug) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_CLINICNAME_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/clinicName`,
        { clinicName },
        config
      );

      dispatch({
        type: TENANT_UPDATE_CLINICNAME_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_CLINICNAME_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const updateTenantSupportEmailAction =
  (supportEmail, slug) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_SUPPORTEMAIL_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants//supportEmail`,
        { supportEmail },
        config
      );

      dispatch({
        type: TENANT_UPDATE_SUPPORTEMAIL_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_SUPPORTEMAIL_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const updateTenantOperatingCountryAction =
  (operatingCountry, slug) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_OPERATINGCOUNTRY_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/operatingCountry`,
        { operatingCountry },
        config
      );

      dispatch({
        type: TENANT_UPDATE_OPERATINGCOUNTRY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_OPERATINGCOUNTRY_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantOnboardingStatusAction =
  (status) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_ONBOARDING_STATUS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const tenantID = userInfo.tenantID;

      const { data } = await axios.put(
        `/api/tenants/${tenantID}/onboarding-status`,
        { status },
        config
      );

      dispatch({
        type: TENANT_UPDATE_ONBOARDING_STATUS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_ONBOARDING_STATUS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const seedDatabaseUpdateOnboardingStatusAction =
  (status, slug) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/onboarding-status-and-seed`,
        { status },
        config
      );

      // ✅ NEW: Update the userInfo.tenants with updated slug
      const updatedTenants = userInfo.tenants.map((tenant) =>
        tenant.tenantID === userInfo.tenantID
          ? { ...tenant, slug: data.slug }
          : tenant
      );

      const updatedUserInfo = {
        ...userInfo,
        token: data.token, // ✅ replace old token
        tenants: data.token
          ? JSON.parse(atob(data.token.split(".")[1])).tenants
          : updatedTenants,
      };

      // console.log("Updated userInfo:", updatedUserInfo);
      // ✅ Update the userInfo in localStorage

      // ✅ Save updated info to localStorage
      localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));

      // ✅ Refresh Redux state
      dispatch({
        type: AUTH_LOGIN_SUCCESS,
        payload: updatedUserInfo,
      });

      dispatch({
        type: TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const updateTenantLogoAction =
  (slug, tenantID, logoUrl) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_LOGO_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json", // ✅ Correct for JSON
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/${tenantID}/update-logo`,
        { logoUrl }, // ✅ correct payload
        config
      );

      // console.log("Logo update response:", data);

      dispatch({
        type: TENANT_UPDATE_LOGO_SUCCESS,
        payload: data,
      });

      // ✅ Fetch updated tenant details so the UI reflects the new logo
      dispatch(listTenantDetailsBySlugAction(slug));
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_LOGO_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantClinicDetailsAction =
  (slug, tenantID, clinicDetails) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_CLINIC_DETAILS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/${tenantID}/clinic-details`,
        clinicDetails,
        config
      );

      dispatch({
        type: TENANT_UPDATE_CLINIC_DETAILS_SUCCESS,
        payload: data,
      });

      // ✅ Fetch updated tenant details so the UI reflects the new logo
      dispatch(listTenantDetailsBySlugAction(slug));
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_CLINIC_DETAILS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantRegionalSettingsAction =
  (slug, tenantID, operatingCountry, currency) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_REGIONAL_SETTINGS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/${tenantID}/update-regional-settings`,
        { operatingCountry, currency },
        config
      );

      dispatch({
        type: TENANT_UPDATE_REGIONAL_SETTINGS_SUCCESS,
        payload: data,
      });

      // ✅ Fetch updated tenant details so the UI reflects the new logo
      dispatch(listTenantDetailsBySlugAction(slug));
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_REGIONAL_SETTINGS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantSchedulingSettingsAction =
  (slug, tenantID, schedulingSettings) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_SCHEDULING_SETTINGS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/${tenantID}/update-scheduling-settings`,
        schedulingSettings,
        config
      );

      dispatch({
        type: TENANT_UPDATE_SCHEDULING_SETTINGS_SUCCESS,
        payload: data,
      });

      dispatch(listTenantDetailsBySlugAction(slug));
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_SCHEDULING_SETTINGS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantDentalChairsAction =
  (slug, tenantID, payload) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_DENTAL_CHAIRS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/${tenantID}/update-dental-chairs`,
        payload,
        config
      );

      dispatch({
        type: TENANT_UPDATE_DENTAL_CHAIRS_SUCCESS,
        payload: data,
      });

      dispatch(listTenantDetailsBySlugAction(slug));
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_DENTAL_CHAIRS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantCompanyDetailsAction =
  (slug, tenantID, companyDetails) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_COMPANY_DETAILS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/${tenantID}/update-company-details`,
        companyDetails,
        config
      );

      // console.log("Company details update response:", data);
      // console.log("slug", slug);
      // console.log("companyDetails", companyDetails);

      dispatch({
        type: TENANT_UPDATE_COMPANY_DETAILS_SUCCESS,
        payload: data,
      });

      // ✅ Fetch updated tenant details so the UI reflects the new logo
      dispatch(listTenantDetailsBySlugAction(slug));
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_COMPANY_DETAILS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantSubscriptionStatusAction =
  (slug, tenantID, subscriptionName, status) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_SUBSCRIPTION_STATUS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // console.log("tenantID", tenantID);
      // console.log("Data to send:", { subscriptionName, status });

      const { data } = await axios.put(
        `/api/${slug}/tenants/${tenantID}/subscriptions/update-subscription-status`, // ✅ Correct API Route
        { subscriptionName, status }, // ✅ Correct Payload
        config
      );

      dispatch({
        type: TENANT_UPDATE_SUBSCRIPTION_STATUS_SUCCESS,
        payload: data,
      });

      // ✅ Fetch updated tenant details so the UI reflects the change
      dispatch(listTenantDetailsBySlugAction(tenantID));
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_SUBSCRIPTION_STATUS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ✅ Action to Fetch Subscription Limits for Any Module
export const getTenantSubscriptionUsageAction =
  (moduleName, slug) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_GET_SUBSCRIPTION_LIMITS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // ✅ Make API call with module name as query param
      const { data } = await axios.get(
        `/api/${slug}/tenants/subscriptions/usage?module=${moduleName}`,
        config
      );

      // console.log("Subscription Limits Data:", data); // ✅ Log the response

      dispatch({
        type: TENANT_GET_SUBSCRIPTION_LIMITS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_GET_SUBSCRIPTION_LIMITS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Action to fetch Stripe invoices with pagination and "show all" support
export const getStripeInvoicesAction =
  (slug, page = 1, pageSize = 20, showAll = false) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_GET_STRIPE_INVOICES_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // Construct the query params based on the provided parameters
      const queryParams = new URLSearchParams({
        page: showAll ? 1 : page,
        pageSize: showAll ? 0 : pageSize, // Set pageSize to 0 if "showAll" is true
        all: showAll.toString(), // Convert showAll boolean to string
      });

      const { data } = await axios.get(
        `/api/${slug}/tenants/subscriptions/invoices?${queryParams}`,
        config
      );

      dispatch({
        type: TENANT_GET_STRIPE_INVOICES_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_GET_STRIPE_INVOICES_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getPublicTenantDetailsAction = (tenantID) => async (dispatch) => {
  try {
    dispatch({ type: TENANT_GET_PUBLIC_DETAILS_REQUEST });

    const { data } = await axios.get(`/api/tenants/public/${tenantID}/`);

    dispatch({
      type: TENANT_GET_PUBLIC_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: TENANT_GET_PUBLIC_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const inviteUserToTenantAction =
  (slug, email, role, permissions, language = "en") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_INVITE_USER_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `/api/${slug}/tenants/invite-user`,
        { email, role, permissions, language },
        config
      );

      // console.log("data from inviteUserToTenantAction:", data);

      dispatch({
        type: TENANT_INVITE_USER_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_INVITE_USER_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantDefaultCoordinatorAction =
  (slug, defaultCoordinator) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_DEFAULT_COORDINATOR_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/update-default-coordinator`,
        { employeeId: defaultCoordinator }, // ✅ match backend
        config
      );

      dispatch({
        type: TENANT_UPDATE_DEFAULT_COORDINATOR_SUCCESS,
        payload: data,
      });

      // ✅ Fetch updated tenant details so the UI reflects the new logo
      dispatch(listTenantDetailsBySlugAction(slug));
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_DEFAULT_COORDINATOR_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateTenantUserPermissionsAction =
  (slug, userId, role, permissions, status) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_UPDATE_TENANT_USER_PERMISSIONS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/tenants/update-user`,
        { userId, role, permissions, status },
        config
      );

      dispatch({
        type: TENANT_UPDATE_TENANT_USER_PERMISSIONS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TENANT_UPDATE_TENANT_USER_PERMISSIONS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deleteTenantAccountAction =
  (slug, language) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_DELETE_ACCOUNT_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
        data: { language }, // ✅ Attach body here
      };

      const { data } = await axios.delete(
        `/api/${slug}/tenants/deactivate-tenant-account`, // USING DEACTIVE NOT DELETE FUNCTION
        config
      );

      dispatch({
        type: TENANT_DELETE_ACCOUNT_SUCCESS,
        payload: data,
      });

      // Optionally, clear user info from localStorage or Redux state
      localStorage.removeItem("userInfo");
      dispatch({ type: AUTH_LOGIN_SUCCESS, payload: null });
    } catch (error) {
      dispatch({
        type: TENANT_DELETE_ACCOUNT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deactivateTenantAccountAction =
  (slug, language) => async (dispatch, getState) => {
    try {
      dispatch({ type: TENANT_DELETE_ACCOUNT_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.patch(
        `/api/${slug}/tenants/deactivate-tenant-account`,
        { language },
        config
      );

      dispatch({
        type: TENANT_DELETE_ACCOUNT_SUCCESS,
        payload: data,
      });

      // Optionally, clear user info from localStorage or Redux state
      localStorage.removeItem("userInfo");
      dispatch({ type: AUTH_LOGIN_SUCCESS, payload: null });
    } catch (error) {
      dispatch({
        type: TENANT_DELETE_ACCOUNT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
